import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { getAccountCategories$ } from '../../../data-access/account-category';
import { AccountCategory, accountCategorySchema } from '../../../models/account-category.schema';
import { Firestore } from '@angular/fire/firestore';
import { select, Store } from '@ngrx/store';
import { selectCurrentUser } from '../../../current-user/store/current-user.selectors';
import { inputIsNotNull } from '../../../data-access/input-is-not-null-or-undefined';
import { handleSchema } from '../../../models/handle-schema';

@Injectable({
  providedIn: 'root',
})
export class GetAccountCategoriesService {
  constructor(private firestore: Firestore, private store$: Store) {
  }

  get(): Observable<AccountCategory[]> {
    return this.store$.pipe(
      select(selectCurrentUser),
      filter(inputIsNotNull),
      take(1),
      switchMap(currentUser =>
        getAccountCategories$(this.firestore, currentUser.accountId).pipe(
          handleSchema(accountCategorySchema, currentUser),
        )
      ),
    );
  }
}
